import React from 'react';
import {
  FormWrapper,
  LoadingAnimation,
  useWizardContext,
} from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { useDetailedOffers } from 'merchant-api/offer';
import { getContract, getDisclosure } from 'merchant-api/checkout';
import { useApplication } from 'merchant-api/unified';
import { TermsAndAgreementsForm } from './TermsAndAgreementsForm';
import * as yup from 'yup';
import { useAtom } from 'jotai';
import { isTermLoan } from '../OfferReview/OfferReview';

const TermsAndAgreementsCheckboxes = yup.object().shape({
  hasDisclosure: yup.boolean(),
  openedDisclosure: yup.boolean()
    .when('hasDisclosure', {
      is: true,
      then: (field) => field.oneOf([true])
    }),
  disclosureCheckbox: yup.boolean()
    .when('hasDisclosure', {
      is: true,
      then: (field) => field.when('openedDisclosure', {
        is: true,
        then: (field2) => field2.test('disclosureCheckbox.error', 'Check the box to continue.', (value) => value === true),
      }).test('disclosureCheckbox.error', 'Open document and check the box to continue.', (field3, context) => {
        return context.parent.openedDisclosure;
      }),
    }),
  termsCheckbox1: yup.boolean().test('termsCheckbox1.error', 'Check the box to continue.', (value) => value === true),
  termsCheckbox2: yup.boolean().test('termsCheckbox2.error', 'Check the box to continue.', (value) => value === true),
  termsCheckbox3: yup.boolean().test('termsCheckbox3.error', 'Check the box to continue.', (value) => value === true),
  termsCheckbox4: yup.boolean().test('termsCheckbox4.error', 'Check the box to continue.', (value) => value === true)
});


export const TermsAndAgreements = () => {

  const { isLoadingApplication, isErrorApplication, applicationData } = useApplication();
  const { selectedOffer, isLoadingDetailedOffers, isErrorOffers, } = useDetailedOffers();
  const { isLoadingContract, openContractPdf, checkoutData, isErrorContract } = getContract();
  const { isLoadingDisclosure, openDisclosurePdf, isErrorDisclosure } = getDisclosure();
  const { goToStep } = useWizardContext();
  const [termLoan, setTermLoan] = useAtom(isTermLoan);

  setTermLoan(selectedOffer?.product === 'TermLoan');

  if (checkoutData?.identityVerificationStatus === 'FAIL') { goToStep('IDENTITY_FAILED') }

  if (isErrorApplication || isErrorOffers || isErrorContract || (checkoutData?.disclosureUuid && isErrorDisclosure)) {
      throw new Error('Error loading terms and agreements');
  }

  if (isLoadingApplication
    || isLoadingDetailedOffers
    || !selectedOffer
    || !checkoutData
    || !applicationData) {
    return (
      <Stack>
        <LoadingAnimation className="mx-auto mt-7" />
      </Stack>
    );
  }

  return (
    <FormWrapper schema={TermsAndAgreementsCheckboxes}>
        <TermsAndAgreementsForm checkoutData={checkoutData} selectedOffer={selectedOffer} applicationData={applicationData} openDisclosurePdf={openDisclosurePdf} openContractPdf={openContractPdf} isLoadingDoc={isLoadingContract || isLoadingDisclosure} />
    </FormWrapper>
  );
}

export default TermsAndAgreements;
